// extracted by mini-css-extract-plugin
module.exports = {"percentageOff":"SalesOffPercentage_percentageOff__aq4Gq"};
module.exports.__checksum = "15e6e85e650b"
